import React from 'react'
import { useIntl, defineMessages } from 'react-intl'
import { styled } from '@mui/material/styles'
import Button from '@mui/material/Button'
import { mikePalette } from '@mike/mike-shared-frontend/mike-shared-styles/mikeSharedTheme'
import { ReactComponent as Users } from '@mike/mike-shared-frontend/media/icons/Users'
import { css } from '@emotion/css'

const localMessages = defineMessages({
  manageAccess: {
    id: 'projectContent.manageAccess'
  }
})

const StyledButton = styled(Button)({
  padding: 0,
  paddingRight: 12,
  width: 170,
  border: '2px solid ' + mikePalette.secondary.main,
  color: mikePalette.secondary.main,
  '&[disabled]': {
    color: mikePalette.secondary.light,
    opacity: 0.5,
    cursor: 'not-allowed'
  }
})

const iconStyle = (disabled: boolean) => {
  const color = disabled
    ? mikePalette.secondary.light
    : mikePalette.secondary.main
  return css`
    path {
      fill: ${color};
    }
  `
}

interface IProps {
  disabled?: boolean
  onClick: () => void
  size?: 'small' | 'medium' | 'large'
}

const FolderAccessButton = ({ disabled = false, ...buttonProps }: IProps) => {
  const intl = useIntl()
  return (
    <StyledButton disabled={disabled} {...buttonProps}>
      <Users className={iconStyle(disabled)} />
      {intl.formatMessage(localMessages.manageAccess)}
    </StyledButton>
  )
}

export default FolderAccessButton
